<template>
  <section v-if="getIsMaster || getIsSuperUser">
    <h1>Awards Reminders</h1>
    <v-btn class="green white--text mt-3" @click="sendReminder">Send reminders</v-btn>
    <v-layout wrap row v-if="isTableVisible">
      <v-flex>
        <v-card class="mt-4">
          <v-data-table
            :headers="headers"
            :items="getAwardsReminders"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="py-4">{{ getUserNameById(props.item.userSentId) }}</td>
              <td class="py-4">{{ getConvertedDate(props.item.sentTime) }}</td>
              <td class="py-4">{{ getEmailTemplateById(props.item.emailTemplateId) }}</td>
              <td class="py-4">{{ props.item.emailsSentQuantity }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { pathOr } from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: "AwardsReminders",
  mixins: [mixins.isWriteAvailable],
  data () {
    return {
       headers: [
        { text: 'User sent name', value: 'userSentId', search: false, sortable: false },
        { text: 'Sent time', value: 'sentTime', search: false, sortable: true },
        { text: 'Email template', value: 'emailTemplateId', search: false, sortable: true },
        { text: 'Emails sent quantity', value: 'emailsSentQuantity', search: false, sortable: true }
      ],
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'awards:write'
    }
  },
  computed: {
    ...mapGetters([
      'getAwardsReminders',
      'getUsersList',
      'getSendGridTemplates',
      'getIsMaster',
      'getIsSuperUser'
    ]),
    isTableVisible () {
      return this.getAwardsReminders && this.getSendGridTemplates
    }
  },
  methods: {
    ...mapActions([
      'fetchAwardsReminders',
      'fetchUsers',
      'fetchEmailTemplates',
      'postAwardReminders',
      'fetchSendGridTemplates'
    ]),
    sendReminder () {
      this.postAwardReminders()
    },
    getConvertedDate (timeStamp) {
      const date = new Date(timeStamp)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()

      return `${year}-${month}-${day} ${hours}-${minutes}-${seconds}`
    },
    getUserNameById (id) {
      const lastModifieduser = this.getUsersList.find(user => user.id === id)
      return lastModifieduser ? lastModifieduser.email : 'User not exists'
    },
    getEmailTemplateById (id) {
      const template = this.getSendGridTemplates.find(item => item.id === id)
      return pathOr('Email template not exists', ['name'], template)
    }
  },
  async created () {
    await this.fetchUsers()
    await this.fetchEmailTemplates()
    await this.fetchSendGridTemplates()
    await this.fetchAwardsReminders()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Awards/Reminders/index.vue